module.exports = __webpack_public_path__ + "static/img/7.8852eda9.png";